import { render, staticRenderFns } from "./UserSection.vue?vue&type=template&id=7a15b862&"
import script from "./UserSection.vue?vue&type=script&lang=js&"
export * from "./UserSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserSection.vue"
export default component.exports